import React, { useMemo, useState } from "react";
import "./team.css";

export const Team = ({ data }) => {
  const [contenidoDesplegado, setContenidoDesplegado] = useState(false);
  const persona = data && data[0];
  const heroImage = persona?.img || "";

  const seccionesBase = [
    {
      titulo: "Área clínica",
      items: [
        "Alcaldía municipio de Popayán: Comisaría de familia y casa de justicia, atención e intervención psicosocial a población vulnerable (víctimas de violencia doméstica e inasistencia alimentaria).",
        "Hospital Universitario San José de Popayán: Atención – interconsulta Unidad de salud mental y programa Madre Canguro.",
        "E.S.E. Popayán: Atención puntos de atención hospitales Toribio Maya y María Occidente.",
      ],
    },
    {
      titulo: "Área social y comunitaria",
      items: [
        "Fundación Plan: Gestión territorial – implementación Ley 1804/16 de atención integral a la primera infancia de Cero a siempre, Comisión Intersectorial de atención integral a la primera infancia – CIPI.",
        "Municipio de Popayán: Referente de Salud mental y Atención a víctimas del conflicto armado.",
        "Fundación PROPARDEC: Atención psicosocial mujeres víctimas del conflicto armado, convenio – Ministerio de Salud y Protección Social.",
        "Empresa social del Estado Popayán E.S.E.: Implementación y coordinación de programa de salud mental.",
        "Empresa Social del Estado Centro 1 E.S.E: Coordinación atención primaria en salud mental.",
        "Fundación Promotora de Desarrollo social FUNPRODESOC: Asistencia psicológica y jurídica - Departamento del Cauca.",
      ],
    },
  ];

  const seccionesExtra = [
    {
      titulo: "Área educativa",
      items: [
        "New Cambridge School College: Psicóloga consejera sección bachillerato - Coordinadora de Learning Support Center.",
        "Institución educativa Don Bosco: Psicóloga orientadora.",
        "Asocaña – Valle del Cauca, operador ICBF: Agente educativa programa familias con bienestar.",
        "Servicio Nacional de Aprendizaje SENA: Instructora ética y transformación del entorno.",
        "Corporación Juan Bosco – operador ICBF: Coordinadora – Educadora del programa clubes juveniles y prejuveniles.",
        "Docente hora cátedra - Escuela de Salud del Cauca ESACAUCA: Psicologa y abogada.",
      ],
    },
    {
      titulo: "Área jurídica",
      items: [
        "Fundación Mujer libre, Carolina del Norte U.S.A Sede en Colombia: Elaboración de peritajes forenses.",
        "Tribunal superior – sala penal de Popayán: Judicante.",
        "Fundación promotora de Desarrollo social FUNPRODESOC: Asesoría jurídica a población vulnerable.",
      ],
    },
    {
      titulo: "Formación complementaria",
      items: [
        "Atención con enfoque psicosocial a víctimas del conflicto armado, Minsalud.",
        "Capacitación Salud sexual y reproductiva, Min Salud.",
        "Capacitación identificación y atención de las afectaciones físicas y mentales de víctimas del conflicto armado, Minsalud.",
        "Entrenamiento en atención y manejo del paciente psiquiátrico, Hospital Universitario San José.",
        "Entrenamiento en Programa Madre Canguro, Fundación Canguro.",
        "Capacitación y aplicación Ley 1804 de 2016 - Atención integral a la primera infancia: estándares y lineamientos para el funcionamiento de los hogares infantiles ICBF, Fundación PLAN.",
        "Diseño y aplicación del Diseño Universal para el Aprendizaje (DUA) y Plan Individual de Ajustes Razonables (PIAR).",
      ],
    },
  ];

  const secciones = useMemo(
    () => (contenidoDesplegado ? [...seccionesBase, ...seccionesExtra] : seccionesBase),
    [contenidoDesplegado]
  );

  return (
    <section id="team" className="profile">
      <div
        className="profile__hero"
        style={
          heroImage
            ? {
                backgroundImage: `linear-gradient(180deg, rgba(8,12,24,0.55), rgba(8,12,24,0.45)), url("${heroImage}")`,
              }
            : undefined
        }
      >
        <div className="profile__hero-inner">
          <p className="profile__eyebrow">Experiencia profesional</p>
          <h2 className="profile__title">{persona?.name || "Perfil Profesional"}</h2>
          <p className="profile__subtitle">{persona?.job || "Especialista"}</p>
          {heroImage ? <img src={heroImage} alt={persona?.name || "Foto de perfil"} className="profile__avatar" /> : null}
        </div>
      </div>

      <div className="profile__body">
        <div className="profile__card">
          <div className="profile__grid">
            {secciones.map((sec) => (
              <div className="profile__panel" key={sec.titulo}>
                <h3 className="profile__panel-title">{sec.titulo}</h3>
                <ul className="profile__list">
                  {sec.items.map((item, idx) => (
                    <li key={`${sec.titulo}-${idx}`}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="profile__actions">
            {contenidoDesplegado ? (
              <button className="profile__btn" onClick={() => setContenidoDesplegado(false)}>
                Mostrar menos
              </button>
            ) : (
              <button className="profile__btn" onClick={() => setContenidoDesplegado(true)}>
                Ver más experiencia
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
